// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#expansion_liste_participants_pc[data-v-08bf97ac]{max-height:calc(100vh - 210px);overflow-y:auto;overflow-x:hidden}.liste_participants .zone_sans_participants[data-v-08bf97ac]{max-height:calc(100vh - 260px);min-height:290px;overflow-y:auto;overflow-x:hidden;padding-top:0}.liste_participants[data-v-08bf97ac]{background-color:transparent}.membreAbsent[data-v-08bf97ac]{background-color:#e0e0e0}", ""]);
// Exports
module.exports = exports;
